// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"782d966f","856":"896f4bb8","952":"07631231"}[chunkId] + ".chunk.js";
};